import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { CartDrawer } from "@/components/CartDrawer";
import { WelcomeModal } from "@/components/WelcomeModal";
import { Home } from "@/pages/Home";
import { Shop } from "@/pages/Shop";
import { ProductDetail } from "@/pages/ProductDetail";
import { Admin } from "@/pages/Admin";
import { Contact } from "@/pages/Contact";
import { PaymentSuccess } from "@/pages/PaymentSuccess";
import { PaymentCancel } from "@/pages/PaymentCancel";
import { Toaster } from "sonner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="min-h-screen bg-obsidian text-slate-100 font-body">
            <Header />
            <CartDrawer />
            <WelcomeModal />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </main>
          </div>
          <Toaster position="top-right" theme="dark" richColors />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
